var _TIME_GRAPH_ID$PRICE_ = {
  TIME_GRAPH_ID: 'gen_time',
  PRICE_GRAPH_ID: 'market_price',
  GENERATOR_MAP_ID: 'gen_map_time',
  SCATTER_PLOT_ID: 'pred_scatter',
  BAR_GRAPH_ID: 'gen_type_bar',
  BAR_GRAPH_YEARLY_ID: 'gen_type_bar_yearly',
  PRICE_GRAPH_OTHER_ID: 'other_price',
  ENERGY_PER_UNIT_GRAPH_ID: 'energy_per_unit',
  REGIONAL_COMPARE_GRAPH_ID: 'regional_compare'
},
    TIME_GRAPH_ID = _TIME_GRAPH_ID$PRICE_.TIME_GRAPH_ID,
    PRICE_GRAPH_ID = _TIME_GRAPH_ID$PRICE_.PRICE_GRAPH_ID,
    GENERATOR_MAP_ID = _TIME_GRAPH_ID$PRICE_.GENERATOR_MAP_ID,
    SCATTER_PLOT_ID = _TIME_GRAPH_ID$PRICE_.SCATTER_PLOT_ID,
    BAR_GRAPH_ID = _TIME_GRAPH_ID$PRICE_.BAR_GRAPH_ID,
    BAR_GRAPH_YEARLY_ID = _TIME_GRAPH_ID$PRICE_.BAR_GRAPH_YEARLY_ID,
    PRICE_GRAPH_OTHER_ID = _TIME_GRAPH_ID$PRICE_.PRICE_GRAPH_OTHER_ID,
    ENERGY_PER_UNIT_GRAPH_ID = _TIME_GRAPH_ID$PRICE_.ENERGY_PER_UNIT_GRAPH_ID,
    REGIONAL_COMPARE_GRAPH_ID = _TIME_GRAPH_ID$PRICE_.REGIONAL_COMPARE_GRAPH_ID;
export { TIME_GRAPH_ID, PRICE_GRAPH_ID, GENERATOR_MAP_ID, SCATTER_PLOT_ID, BAR_GRAPH_ID, BAR_GRAPH_YEARLY_ID, PRICE_GRAPH_OTHER_ID, ENERGY_PER_UNIT_GRAPH_ID, REGIONAL_COMPARE_GRAPH_ID };